<template>
  <div>
    <div
      class="w-full"
      style="position: relative; text-align: center; color: white"
    >
      <img src="../assets/images/01.jpg" alt="Logo" style="width: 100%" />
      <p
        class="w-11/12 p-2 bigP almostCenterP flex-1 text-white text-center font-bold px-4 py-2 m-2"
        style="text-shadow: 2px 2px 4px #000000"
      >
        Seguros de Accidentes y Enfermedades
      </p>
      <p
        class="w-11/12 mediumP centerP flex-1 text-white text-center font-bold px-4 py-2 m-2"
        style="text-shadow: 2px 2px 4px #000000"
      >
        Mantente protegido ante cualquier imprevisto
      </p>
    </div>

    <div class="bg-gray-300 p-1">
      <div class="container bg-gray-100 rounded-lg p-2 mt-3 mb-3 box-shadow">
        <p class="text-center text-lg lg:text-5xl lg:leading-8 lg:mt-5 lg:mb-5">
          Un aliado para tu futuro 
        </p>
        <div class="flex">
          <p class="w-full text-left text-xs lg:text-2xl lg:leading-8 px-4 py-2">
            LÍNEA MAGISTERIAL® consciente de la necesidad de protección de tu
            persona, familia y de los bienes materiales que conforman tu
            patrimonio, pone a tu alcance nuestros programas de beneficios con
            el que podrás estar protegido contra la mayoría de los riesgos a los
            que estas expuesto.
          </p>
        </div>

        <div class="w-full px-5 text-center">
          <!-- <router-link
                    :to="{ name: 'quotation' }"
                    class="font-semibold text-xl tracking-tight"> -->
          <button
            @click="createEmptyPolicy()"
            class="w-full flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-3 rounded"
          >
            Cotizar Coberturas <mdicon name="chevron-right" />
          </button>
          <!-- </router-link> -->
        </div>
      </div>
    </div>

    <div class="container mt-2">
      <p class="text-base lg:text-4xl leading-8 text-center mx-4 mb-2 lg:mb-5">
        Ventajas de formar parte de Línea Magisterial 
      </p>
      <div class="w-full p-2 mt-2 mb-5 inline-flex">
        <div class="w-1/3 text-center">
          <span class="dot">
            <!-- <md-icon class="mt-10 text-6xl text-white">account_balance_wallet</md-icon> -->
            <svg
              class="ml-4 mt-4 h-16 w-16 fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22 24"
            >
              <path
                class="secondary"
                d="M18 14.74a4 4 0 00-8 .26H3a2 2 0 01-2-2V5c0-1.1.9-2 2-2h14a2 2 0 012 2v8a2 2 0 01-1 1.74zM10 12a3 3 0 100-6 3 3 0 000 6z"
              />
              <path
                class="primary"
                d="M7 9h14a2 2 0 012 2v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8c0-1.1.9-2 2-2zm7 9a3 3 0 100-6 3 3 0 000 6z"
              />
            </svg>
          </span>
          <p class="mt-3">Tarifas Preferenciales</p>
        </div>
        <div class="w-1/3 text-center">
          <span class="dot">
            <!-- <md-icon class="mt-10 text-6xl text-white">credit_card</md-icon> -->
            <svg
              class="ml-4 mt-4 h-16 w-16 fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="265 393 64 56"
            >
              <defs />
              <path
                d="M329.8 424.33c-.243.346-.495.686-.728 1.038-1.204 1.82-3 2.426-5.062 2.428-2.317.002-7.591.034-7.908-.001-1.508-.168-2.425-1.244-2.376-2.603.048-1.316.95-2.258 2.432-2.303 2.397-.073 4.797-.032 7.195-.039.428-.001.857 0 1.345 0v-24.673h-54.342v24.673h1.459c7.197 0 14.393-.003 21.59.002 1.688.001 2.637.685 2.813 1.987.235 1.742-.732 2.93-2.657 2.959h-21.942c-2.896.041-5.133-.956-6.379-3.708v-27.36c.877-1.747 2.196-2.994 4.08-3.6h56.16c1.972.562 3.441 1.726 4.32 3.6v27.6zM281.473 448.862c-1.791-1.601-1.414-4.237.69-6.441 2.869-3.007 5.839-5.918 8.735-8.841 1.943 1.865 3.803 3.65 5.773 5.542-1.057 1.103-2.06 2.162-3.076 3.207-1.673 1.72-3.761 3.851-5.511 5.489-2.027 1.658-4.366 3.05-6.611 1.044z"
              />
              <path
                d="M318.106 413.747c-1.887 3.456-3.093 7.322-5.89 10.235-2.575 2.682-5.243 5.274-7.875 7.901-1.577 1.575-3.163 3.141-4.711 4.678-1.982-1.965-3.929-3.896-5.416-5.37 3.29-3.543 6.56-7.1 9.875-10.615 1.122-1.189 2.234-2.452 3.569-3.359 1.934-1.314 4.066-2.337 6.115-3.482.588-.329 1.163-.69 1.776-.964.787-.353 1.85-1.257 2.572-.805.722.453.208 1.372-.015 1.781zM286.355 402.97c3.155 0 6.31-.019 9.465.008 1.81.015 2.862.903 2.898 2.347.03 1.208-.694 2.178-1.893 2.414-.621.122-1.27.146-1.906.147-5.751.01-11.502.009-17.253.002-.517-.001-1.04-.022-1.55-.098-1.331-.2-2.07-1.049-2.093-2.347-.023-1.305.674-2.183 2.034-2.387.783-.118 1.592-.079 2.39-.082 2.636-.009 5.272-.004 7.908-.004zM295.874 410.451c1.756.004 2.737.787 2.835 2.237.1 1.473-.861 2.504-2.643 2.587-2.112.099-14.336.059-18.33.052-.517-.001-1.04-.016-1.551-.09-1.432-.207-2.23-1.168-2.15-2.536.082-1.406.93-2.232 2.427-2.244 3.316-.024 16.257-.012 19.412-.006zM313.706 407.809c-1.635 0-3.27.016-4.905-.005-1.536-.02-2.474-.891-2.519-2.289-.046-1.439.872-2.461 2.448-2.513 2.193-.073 4.389-.029 6.584-.032 1.078-.001 2.157-.034 3.232.016 1.627.076 2.5.968 2.489 2.456-.011 1.512-.882 2.339-2.544 2.362-1.595.023-3.19.006-4.785.005zM290.648 447.502c0-.823.573-1.312 1.042-1.787 2.949-2.984 5.949-5.919 8.939-8.862.31-.305.638-.616 1.013-.827.941-.531 1.787-.297 2.455.502.66.79.641 1.689-.055 2.392-3.372 3.409-6.765 6.797-10.218 10.122-.465.434-1.244.516-1.796.388-.82-.19-1.318-.871-1.38-1.928z"
              />
            </svg>
          </span>
          <p class="mt-3">Descuentos Vía Nómina</p>
        </div>
        <div class="w-1/3 text-center">
          <span class="dot">
            <!-- <md-icon class="mt-10 text-6xl text-white">headset_mic</md-icon> -->
            <svg
              class="ml-4 mt-3 h-16 w-16 fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22 22"
            >
              <path
                class="primary"
                d="M22 17a1 1 0 01-2 0v-5a8 8 0 10-16 0v5a1 1 0 01-2 0v-5a10 10 0 1120 0v5z"
              />
              <path
                class="secondary"
                d="M7 12a2 2 0 012 2v6a2 2 0 11-4 0v-6c0-1.1.9-2 2-2zm10 0a2 2 0 012 2v6a2 2 0 11-4 0v-6c0-1.1.9-2 2-2z"
              />
            </svg>
          </span>
          <p class="mt-3">Asesoría Especializada</p>
        </div>
      </div>
    </div>

    <div class="bg-gray-300 p-2">
      <div class="p-2 lg:p-5">
        <p class="text-2xl lg:text-4xl text-center font-bold">
          Nuestras coberturas
        </p>
      </div>
      <div
        class="container bg-gray-100 mt-2 mb-4 rounded-lg box-shadow p-5"
        v-for="benefit in benefits"
        :key="benefit.id"
      >
        <img :src="benefit.img" alt="Logo" style="width: 100%" />

        <div class="w-full p-2 text-center -mt-8">
          <p
            v-if="benefit.titulo == 'Accidentes Personales'"
            class="w-full bg-yellow-500 p-2 text-xl lg:text-4xl leading-8 text-white font-bold py-2 rounded"
            style="position: relative"
          >
            {{ benefit.titulo }}
          </p>

          <p
            v-else-if="benefit.titulo == 'lndemnizaciones por Cáncer'"
            class="w-full bg-pink-500 p-2 text-xl lg:text-4xl leading-8 text-white font-bold py-2 rounded"
            style="position: relative"
          >
            {{ benefit.titulo }}
          </p>

          <p
            v-else-if="benefit.titulo == 'Respaldo Hospitalario'"
            class="w-full bg-blue-400 p-2 text-xl lg:text-4xl leading-8 text-white font-bold py-2 rounded"
            style="position: relative"
          >
            {{ benefit.titulo }}
          </p>

          <p
            v-else-if="
              benefit.titulo == 'Indemnización por Enfermedades Graves'
            "
            class="w-full bg-red-600 p-2 text-xl lg:text-4xl leading-8 text-white font-bold py-2 rounded"
            style="position: relative"
          >
            {{ benefit.titulo }}
          </p>

          <p
            v-else-if="benefit.titulo == 'Pérdida de Ingresos'"
            class="w-full bg-teal-400 p-2 text-xl lg:text-4xl leading-8 text-white font-bold py-2 rounded"
            style="position: relative"
          >
            {{ benefit.titulo }}
          </p>
        </div>

        <div class="flex text-left content-center flex-wrap h-50">
          <p
            v-html="benefit.descripcion"
            class="text-sm lg:text-2xl lg:leading-7 py-2 m-2"
          ></p>
        </div>
        <div class="mt-2 text-gray-500">
          <p class="flex" v-if="!showBenefits" v-on:click="toggleShowPrices">
            Ver más información <mdicon name="chevron-down" />
          </p>
          <p class="flex" v-if="showBenefits" v-on:click="toggleShowPrices">
            Ocultar información <mdicon name="chevron-up" />
          </p>
        </div>

        <div class="mt-2 text-left" v-show="showBenefits">
          <p class="text-blue-900 text-base lg:text-xl font-bold mb-2">
            Ventajas
          </p>
          <p
            v-html="ventajas"
            class="text-xs lg:text-base mb-0"
            v-for="ventajas in benefit.ventajas"
            :key="ventajas.id"
          ></p>

          <p class="text-blue-900 text-base lg:text-xl font-bold mt-2 mb-2">
            Beneficios del Plan
          </p>
          <p
            v-html="beneficios"
            class="text-xs lg:text-base mb-0"
            v-for="beneficios in benefit.beneficios"
            :key="beneficios.id"
          ></p>

          <p class="text-blue-900 text-base lg:text-xl font-bold mt-2 mb-2">
            Cobertura:
          </p>

          <p
            v-if="benefit.cobertura_sin_plan"
            v-html="benefit.cobertura_sin_plan"
            class="text-xs lg:text-base mb-0"
          ></p>

          <table
            v-if="benefit.coberturas"
            class="mt-2 mb-5"
            style="width: 100%"
          >
            <tr>
              <th
                class="text-xs lg:text-base font-bold"
                style="text-align: left"
              ></th>
              <th
                class="text-xs lg:text-base font-bold"
                style="text-align: left"
              >
                Plan A
              </th>
              <th
                class="text-xs lg:text-base font-bold"
                style="text-align: left"
              >
                Plan B
              </th>
            </tr>
            <tr v-for="cobertura in benefit.coberturas" :key="cobertura.id">
              <td class="text-xs lg:text-base">{{ cobertura.nombre }}</td>
              <td
                class="text-orange-500 font-bold text-xs lg:text-base"
                style="text-align: left"
              >
                {{ cobertura.plan_a }}
              </td>
              <td
                class="text-orange-500 font-bold text-xs lg:text-base"
                style="text-align: left"
              >
                {{ cobertura.plan_b }}
              </td>
            </tr>
          </table>

          <p
            v-html="benefit.edad_aceptacion"
            class="text-sm lg:text-base mb-2"
          ></p>

          <p
            v-html="benefit.edad_cancelacion"
            class="text-sm lg:text-base mb-2"
          ></p>

          <p
            v-if="benefit.periodo_espera"
            v-html="benefit.periodo_espera"
            class="text-sm lg:text-base mb-2"
          ></p>

          <p class="text-blue-900 text-sm lg:text-base font-bold mb-2">
            Principales exclusiones
          </p>
          <p
            v-html="principales_exclusiones"
            class="text-xs lg:text-base mb-0"
            v-for="principales_exclusiones in benefit.principales_exclusiones"
            :key="principales_exclusiones.id"
          ></p>
        </div>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <router-link
            :to="{ name: 'quotation' }"
            class="font-semibold text-xl tracking-tight"
          >
            <button
             @click="createEmptyPolicy()"
              class="w-full flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
            >
              Cotizar<mdicon name="chevron-right" />
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <div
      class="w-full"
      style="position: relative; text-align: right; color: white"
    >
      <img src="../assets/images/02.jpg" alt="Logo" style="width: 100%" />
      <p
        class="w-11/12 p-2 bigP bottom-right-p flex-1 text-white font-bold px-4 py-2 m-2"
        style="text-shadow: 2px 2px 4px #000000"
      >
        La tranquilidad y la seguridad de las familias de los trabajadores de la
        educación se adquieren con LÍNEA MAGISTERIAL®.
      </p>
    </div>

    <div class="p-5">
      <svg
        class="w-full mt-5 mb-5 h-8 w-8 fill-current text-orange-600"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="265.24 393.13 64.56 56.88"
      >
        <defs />
        <switch>
          <g>
            <path
              d="M266.126 396.429h24.84v24.873h-12.402c-.242 3.785 1.145 6.665 3.511 9.116 2.058 2.131 4.584 3.383 7.563 3.764.523.067 1.375.724 1.387 1.129.109 3.642.063 7.289.063 11.402-2.289-.369-4.414-.532-6.441-1.068-10.881-2.874-18.494-12.827-18.519-24.103-.017-7.732-.003-15.464-.003-23.196.001-.587.001-1.174.001-1.917zM304.173 396.427h24.597v24.829h-12.481c.135 1.216.15 2.199.364 3.136 1.194 5.213 5.454 9.077 10.726 9.719.964.117 1.556.327 1.54 1.478-.047 3.531-.017 7.063-.017 11.125-2.299-.381-4.478-.542-6.542-1.117-10.049-2.8-17.385-11.143-18.055-21.558-.58-9.011-.257-18.079-.327-27.122 0-.108.083-.216.195-.49z"
            />
          </g>
        </switch>
      </svg>
      <p class="text-gray-600 text-center text-base leading-6 italic p-4 -m-4">
        "Lo mejor son los precios accesibles, me siento seguro teniendo el
        respaldo para mi familia".
      </p>
      <p class="text-center font-bold">Juan José López Pérez</p>
      <p class="text-center">Hermosillo, Sonora</p>
    </div>

    <div class="w-full px-5 text-center mb-5">
      <router-link
        :to="{ name: 'ask-for-help' }"
        class="font-semibold text-xl tracking-tight"
      >
        <button
        @click="createEmptyPolicy()"
          class="w-full flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
        >
          Solicitar ayuda de un asesor <mdicon name="chevron-right" />
        </button>
      </router-link>
    </div>

    <div class="w-full px-5 text-center mb-5">
      <router-link
        :to="{ name: 'quotation' }"
        class="font-semibold text-xl tracking-tight"
      >
        <button
          @click="createEmptyPolicy()"
          class="w-full flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
        >
          Cotizar Coberturas <mdicon name="chevron-right" />
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";
import Json from "../assets/benefits.json";
import emptyPolicy from "../assets/EmptyPolicy.json";


export default {
  name: "Home",

  data() {
    return {
      ccapi: process.env.VUE_APP_CCAPI,
      token: "",
      policy: null,
      benefits: Json,
      showBenefits: false,
      reference_is_valid: false
    };
  },
  async mounted() {
    await this.login();
    localStorage.clear();
    sessionStorage.clear();
    console.log("Router params", this.$router)
    console.log("Router this.$route.query", this.$route.query.reference?.trim())
    console.log("Router params mounted", this.$router.currentRoute._value.query.reference)
    if(this.$route.query.reference != undefined){
      if(this.$route.query.reference !== ""){
        await this.referenceIsAvailable(this.$route.query.reference)
        
        if(this.reference_is_valid == false){
          Swal.fire({
            title: "Referencia inválida",
            html: "La referencia del asesor es inválida, si continua con el registro se realizara sin referencia.",
            icon: "info",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK"
          });
        }else{
          sessionStorage.setItem("reference",this.$route.query.reference?.trim())
        }

      }
    }
  },
  
  methods: {
    toggleShowPrices() {
      this.showBenefits = !this.showBenefits;
    },
    createEmptyPolicy() {
      this.policy = emptyPolicy;
      this.addReferenceModel(this.policy);
    },
    addReferenceModel(policy) {
      localStorage.setItem("policy", JSON.stringify(policy));
      console.log("route params", this.$route.params)
      // localStorage.clear();
      if (this.$router.currentRoute._value.query.reference != null) {
      console.log("addReferenceMode paramsl");
        sessionStorage.setItem("reference", this.$router.currentRoute._value.query.reference?.trim());
      }
      this.validateInfo();
    },
    validateInfo() {
      //cambiar nombre de método
      if (JSON.parse(localStorage.getItem("policy")) != null) {
        this.$router.push({ name: "quotation" });
      } else {
        console.log("No se creo póliza");
      }
    },
    saveInLocalStorage() {},
    async login() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          password: "cabsa2022",
          email: "aplm@gcabsa.com.mx",
        },
      };
      await axios
        .post(this.ccapi + "/fas/login", data, config)
        .then((response) => {
          this.token = response.data.token_auth;
        });
    },
    async referenceIsAvailable(reference){
      await axios.get(this.ccapi+"/cabsaaye/associate/reference_is_available", {
        params: {
          token_auth: this.token,
          reference: reference
        },
      })
      .then((response) => {
        this.reference_is_valid = response.data.reference_is_valid;
      }).catch(()=> {
        this.reference_is_valid = false;
      });
    }
  },
};
</script>

<style scoped>
.bigP {
  font-size: 4vw;
  line-height: 4vw;
}
.mediumP {
  font-size: 3vw;
  line-height: 3vw;
}
.centerP {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.almostCenterP {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -150%);
}
.bottom-right-p {
  position: absolute;
  bottom: 8px;
  right: 16px;
}
.dot {
  height: 100px;
  width: 100px;
  background-color: #8cba51;
  border-radius: 250%;
  display: inline-block;
}
a{
  text-decoration: none !important;
}
.md-card {
  width: 400px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.align-to-right {
  text-align: right;
}
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}

@media only screen and (max-width: 1026px) {
  #onlylg {
    display: none;
  }
}
</style>